import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container, Heading, Paragraph } from '@scentregroup/ui'
import CardListV2 from '../card-list-v2'
import TabsHeaderV2 from '../tabs-v2/tabs-header-v2'
import { slugify } from '../../helpers'
import {
  SEE_MORE_MOVIES_TEXT,
  MIN_MOVIES_TO_SHOW,
  MIN_MOVIES_TO_SHOW_V2,
} from '../../constants'
import style from './index.module.scss'

export const fromMovie = (centreId, date) => m => ({
  title: m.title,
  link: `/${centreId}/movie/${m.id}/${slugify(m.title)}${
    date ? `/${date}` : ''
  }`,
  image: m.image,
  classification: m.classification,
  category: m.genres && m.genres[0],
})

class FilteredCardList extends Component {
  state = {
    activeTab: 0,
    minItems: this.context ? MIN_MOVIES_TO_SHOW_V2 : MIN_MOVIES_TO_SHOW,
  }
  switchTabs = activeTabIndex => {
    this.setState({
      activeTab: activeTabIndex,
      minItems: null,
    })
  }

  selectAllTab = () => {
    this.setState((_state, props) => ({
      activeTab: props.tabHeadings
        .map(heading => heading.displayDate)
        .indexOf('All'),
    }))
  }

  getCardsForList() {
    const { tabHeadings, entries: movies, centreSlug } = this.props
    const { activeTab } = this.state
    const activeTabDate = tabHeadings[activeTab].date
    return movies
      .filter(
        movie =>
          activeTabDate === 'All' || movie.sessions.includes(activeTabDate)
      )
      .map(fromMovie(centreSlug, activeTabDate !== 'All' && activeTabDate))
  }

  render() {
    const { tabHeadings, title } = this.props
    const numberOfTabs = tabHeadings.length
    const selectedTab = Math.min(numberOfTabs, this.state.activeTab)
    const headings = [...tabHeadings].splice(0, numberOfTabs)
    const unsuccessfulText =
      "We haven't confirmed movies for that day yet. How about trying another day?"

    const cardsForList = this.getCardsForList()

    return (
      <Container centred type="large" className={style.evolved}>
        <div className={style.headings}>
          <Heading type="large" className={style.title}>
            {title}
          </Heading>
          <TabsHeaderV2
            headings={headings.map(tabHeading => tabHeading.displayDate)}
            selectedTab={selectedTab}
            onTabHeadingClick={this.switchTabs}
          />
        </div>
        {cardsForList.length > 0 && (
          <CardListV2
            cards={cardsForList}
            buttonText={SEE_MORE_MOVIES_TEXT}
            minItems={this.state.minItems}
          />
        )}
        {cardsForList.length === 0 && (
          <div className={style.unsuccessful}>
            <Paragraph type="large" className={style.unsuccessfulText}>
              {unsuccessfulText}
            </Paragraph>
            <button
              className={style.callToActionLink}
              onClick={this.selectAllTab}
            >
              {SEE_MORE_MOVIES_TEXT}
            </button>
          </div>
        )}
      </Container>
    )
  }
}

FilteredCardList.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      genre: PropTypes.string,
      classification: PropTypes.string,
      sessions: PropTypes.array,
    })
  ).isRequired,
  centreSlug: PropTypes.string,
  tabHeadings: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default FilteredCardList
